<template>
  <div class="tab-box-wrapper">

    <!-- 头部切换 -->
    <div class="tab-header" :class="nowTabType">
      <h6 :class="{'active': itemHeader.type === nowTabType}" v-for="(itemHeader, indexHeader) in tabHeaderMap" :key="`${itemHeader}&${indexHeader}`" @click="toggleTabFunc(itemHeader.type)">
        {{ itemHeader.type === 'myCv' ? `${itemHeader.text} (${cvsTotalCount})` : itemHeader.text }}
      </h6>
      <div class="resume-actions" v-if="cvs && cvs.length">
        <div class="action-btn import" @click="triggerCreateCvFunc('import')" data-growing-container data-growing-idx="304"><span>导入简历</span></div>
        <div class="action-btn create" @click="triggerCreateCvFunc('template')" data-growing-container data-growing-idx="303"><span>新建简历</span></div>
      </div>
    </div>

    <!-- 内容展示 -->
    <div class="tab-content" v-loading="templateListLoading || recycleBinListLoading">

      <!-- 我的简历 内容区域 -->
      <div v-show="nowTabType === 'myCv'">

        <!-- 各种提示 -->
        <!-- 1. 会员过期提示 -->
        <div v-if="userMemberStatus === 'timeout'" class="tips-box member" :style="notSelectedMentorOrders.count ? {marginBottom: '10px'} : {}">
          <!-- <img class="tips-icon" src="https://logo.wondercv.com/banners/1EYwvMTHqfYLn8a.png" alt=""> -->
          <img class="tips-icon" src="@/assets/image/cvs/tips-icon.svg" alt="">
          <p>您的超级简历会员已到期，点击续费，或选择一份简历进行免费编辑<span @click.stop="toBuyMemberFunc()">立即续费 ></span></p>
        </div>
        <!-- 2. 导师简历信息未完善提示 -->
        <div v-if="notSelectedMentorOrders.count" class="tips-box mentor">
          <!-- <img class="tips-icon" src="https://logo.wondercv.com/banners/1EYwvMTHqfYLn8a.png" alt=""> -->
          <img class="tips-icon" src="@/assets/image/cvs/tips-icon.svg" alt="">
          <p>你的简历修改服务信息未完善，简历完善后才可分配导师<span @click.stop="perfectUrlFunc()">立即完善 ></span></p>
        </div>

        <div class="resume-swiper" v-if="cvs && cvs.length">
          <div class="swiper-prev iconfont iconarrow-left2" @click="changeResumePage('cvs', 'prev')" v-if="myCvActiveIndex!==0"></div>
          <div class="swiper-next iconfont iconarrow-left2" @click="changeResumePage('cvs', 'next')" v-if="myCvActiveIndex<cvsSwiper.page-1"></div>
          <div class="resume-scroll">
            <div class="resume-scroll-body" :style="{width: `${1200 * cvsSwiper.page + (cvsSwiper.page-1) *20}px`, transform: `translateX(-${myCvActiveIndex * 1200 + myCvActiveIndex*20}px)`}">
              <div class="resume-list my-resume-list" v-for="(swiperItem, swiperIndex) in cvsSwiper.list" :key="`swiperItem-${swiperIndex}`">
                <!-- 简历卡片（类型：草稿简历） -->
                <comp-cv-item previewType="draft"
                              v-for="(itemCv, indexCv) in swiperItem" 
                              :key="`${itemCv.token}&${indexCv}`"
                              :data="itemCv"
                              :indexSelf="indexCv"
                              :indexNow="cvActiveIndex"
                              :userLock="userLock"
                              @changeConfirmState="changeConfirmState"
                              @triggleCvUpdatedFunc="triggleCvUpdatedFunc"
                              @triggleShowCvHandleBoxFunc="triggleShowCvHandleBoxFunc"
                              @editCvName="editCvName"
                              @updateSelectCvData="updateSelectCvData"
                              />
              </div>
            </div>
          </div>
        </div>
  
        <!-- 没有数据 -->
        <div class="create-cvs" v-else>
          <div class="create-cv-btn create" @click="triggerCreateCvFunc('template')" data-growing-container data-growing-idx="303">
            <img src="@/assets/image/cvs/resume-create.svg">
            <div class="label">新建简历</div>
            <div class="tips"></div>
          </div>
          <div class="create-cv-btn import" @click="triggerCreateCvFunc('import')" data-growing-container data-growing-idx="304">
            <img src="@/assets/image/cvs/resume-import.svg">
            <div class="label">导入简历</div>
            <div class="tips">支持 Word、PDF、PNG 或 JPG 等格式文件</div>
          </div>
        </div>
        <!-- <div class="no-data-box myCv" v-else>
          <img src="https://files.wondercv.com/PC/cvs/myresume_default.png" alt="">
          <p>暂无简历信息</p>
        </div> -->

      </div>

      <!-- 收藏模板 内容区域 -->
      <div v-show="nowTabType === 'collectTemplate'" class="collectTemplate-list-box">
        <div  class="tips-box member">
          <img class="tips-icon" src="@/assets/image/cvs/tips-icon.svg" alt="">
          <p>收藏站仅保存最近收藏至多10份简历模板</p>
        </div>
        <div class="template-list" v-if="templateList && templateList.length">
          <!-- 模板卡片 -->
          <comp-template-item v-for="(itemTemp, indexTemp) in templateList"
                              :key="`${itemTemp.token}&${indexTemp}`"
                              :data="itemTemp" />
          <!-- <img class="banner-more-template" src="https://files.wondercv.com/PC/cvs/resume_template.png" alt="" @click.stop="toMoreTemplateFunc()" data-growing-container data-growing-idx="306"> -->
          <img class="banner-more-template" src="@/assets/image/cvs/resume_template.jpg" alt="" @click.stop="toMoreTemplateFunc()" data-growing-container data-growing-idx="306">
        </div>

        <!-- 没有数据 -->
        <div class="no-data-box collectTemplate" v-else>
          <!-- <img src="https://files.wondercv.com/PC/cvs/tamplate_default.png" alt=""> -->
          <img src="https://files.wondercv.com/cvs/not-resume-icon.svg" alt="">
          <p>暂无收藏模板</p>
        </div>

      </div>

      <!-- 回收站 内容区域 -->
      <div v-show="nowTabType === 'recycleBin'">

        <!-- 回收站提示 -->
        <div class="tips-box member" v-if="recycleBinList && recycleBinList.length">
          <!-- <img class="tips-icon" src="https://logo.wondercv.com/banners/1EYwvMTHqfYLn8a.png" alt=""> -->
          <img class="tips-icon" src="@/assets/image/cvs/tips-icon.svg" alt="">
          <p>回收站保存最近<span>30</span> 天内删除的 10 份简历，彻底删除后将无法恢复，请谨慎操作！</p>
        </div>
        <div class="resume-swiper" v-if="recycleBinList && recycleBinList.length">
          <div class="swiper-prev iconfont iconarrow-left2" @click="changeResumePage('deleteCvs', 'prev')" v-if="delectCvActiveIndex!==0"></div>
          <div class="swiper-next iconfont iconarrow-left2" @click="changeResumePage('deleteCvs', 'next')" v-if="delectCvActiveIndex<deleteCvsSwiper.page-1"></div>
          <div class="resume-scroll">
            <div class="resume-scroll-body" :style="{width: `${1200 * deleteCvsSwiper.page + (deleteCvsSwiper.page-1) *20}px`, transform: `translateX(-${delectCvActiveIndex * 1200 + delectCvActiveIndex*20}px)`}">
              <div class="resume-list delete-resume-list" v-for="(swiperItem, swiperIndex) in deleteCvsSwiper.list" :key="`swiperItem-${swiperIndex}`">
                <!-- 简历卡片（类型：已删除简历） -->
                <comp-cv-item previewType="delete"
                        v-for="(itemDelate, indexDelate) in swiperItem" 
                        :key="`${itemDelate.token}&${indexDelate}`"
                        :data="itemDelate"
                        :userLock="userLock"
                        @triggleCvUpdatedFunc="triggleCvUpdatedFunc"
                        @triggleUpdateDeleteCvListFunc="getRecycleBinDataFunc"
                        @updataTrashAlertBox="updataTrashAlertBox"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 没有数据 -->
        <div class="no-data-box recycleBin" v-else>
          <!-- <img src="https://files.wondercv.com/PC/cvs/trash_default.png" alt=""> -->
          <img src="https://files.wondercv.com/cvs/not-resume-icon.svg" alt="">
          <p>暂无已删除简历</p>
        </div>

      </div>

    </div>

    <!-- 修改简历名称弹窗 -->
    <renameModal v-if='renameModalData.show' :cvToken="renameModalData.cvToken" :cvName="renameModalData.cvName" @editCvName='editCvName'
      :isDarkTheme="true"
    />
    <!-- 选择简历弹窗 -->
    <select-cv
      :cvsEn="selectCvData.cvsEn"
      :cvsCn="selectCvData.cvsCn"
      :isDarkTheme="true"
      v-if="selectCvData.show"
      @updated="triggleCvUpdatedFunc"
      @close="selectCvData.show = false"/>
    <!-- 删除简历弹窗 -->
    <trash-alert :show="trashAlertBox.show" :title="trashAlertBox.title" :button-name="trashAlertBox.buttonName"
                :content="trashAlertBox.content" @confirm="trashAlertBox.confirm" @close="trashAlertBox.show = false"
                :hide-close-btn="trashAlertBox.hideCloseBtn" :isDarkTheme="trashAlertBox.isDarkTheme"
                />
  </div>
</template>

<script>
import CompCvItem from '@/components/page/cvs/cv-item'
import CompTemplateItem from '@/components/page/cvs/template-item'
import renameModal from '@/components/renameModal'
import selectCv from '@/views/cvs/components/selectCv'
import trashAlert from '@/components/trashAlert'

import api from '@/api'
import moment from 'moment'
import { mapMutations, mapState } from 'vuex'
import { routerTo, userMemberCheck, splitArray } from '@/assets/js/util'
import { transform } from 'lodash'

export default {
  props: {
    // 没有完善信息的导师订单数
    notSelectedMentorOrders: {
      type: Object,
      default: {
        count: 0
      }
    },
    userLock: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      moment,
      /** 
       * 临时存储 相关
      */
      nowTabType: 'myCv', // 当前活跃 tab 类型
      userMemberStatus: null,
      templateList: [], // 简历模板列表
      templateListLoading: false, // 简历模板列表请求中
      templateListEnd: false, // 简历模板列表请求中
      recycleBinList: [], // 回收站简历列表
      recycleBinListLoading: false, // 回收站简历列表请求中
      recycleBinListEnd: false, // 回收站简历列表请求中
      // indexNow: null, // 活跃浮窗的简历索引
      /** 
       * 映射 相关
      */
      tabHeaderMap: [ // tab header 地图
        {
          type: 'myCv',
          text: '我的简历'
        },
        {
          type: 'collectTemplate',
          text: '收藏模板'
        },
        {
          type: 'recycleBin',
          text: '回收站'
        }
      ],
      myCvActiveIndex: 0, // 我的简历 活跃索引
      delectCvActiveIndex: 0, // 回收站简历 活跃索引

      renameModalData: { // 修改简历名称弹窗
        show: false,
        cvToken: '',
        cvName: ''
      },
      selectCvData: { // 选择简历弹窗
        show: false,
        cvsEn: [],
        cvsCn: []
      },
      trashAlertBox: {
        show: false,
        title: '清空回收站',
        content: '',
        buttonName: '确定',
        confirm: () => {}
      }
    }
  },
  components: {
    CompCvItem, // 草稿简历 组件
    CompTemplateItem, // 简历模板 组件
    renameModal, // 修改简历名称弹窗
    selectCv, // 选择简历弹窗
    trashAlert
  },
  created () {
    // 获取 用户会员状态
    this.userMemberStatus = userMemberCheck(this.personInfo.membership_expired_at)
    // 获取 回收站简历列表
    // this.getRecycleBinDataFunc()
    // 获取 收藏的简历模板列表
    // this.getCollectTemplateDataFunc()
  },
  computed: {
    ...mapState('me', ['personInfo']),
    ...mapState('cv', [ 'cvs', 'cvsTotalCount', 'cvActiveIndex' ]),
    cvsSwiper(){
      let cvsList = this.cvs || []
      let list = splitArray(cvsList, 5)
      return {
        list,
        page: list.length
      }
    },
    deleteCvsSwiper(){
      let recycleBinList = this.recycleBinList || []
      let list = splitArray(recycleBinList, 5)
      return {
        list,
        page: list.length
      }
    }
  },
  methods: {
    ...mapMutations('cv', ['setCvActiveIndex']),
    triggleShowCvHandleBoxFunc (i) {
      // this.indexNow = i
      this.setCvActiveIndex(i)
    },
    triggleCvUpdatedFunc () {
      this.$emit('triggleCvUpdatedFunc')
      this.getRecycleBinDataFunc()
    },
    // 切换 tab 类型
    toggleTabFunc (val) {
      this.nowTabType = val
      this.$emit('updateSelectedTab', val)
      if(val === 'collectTemplate' && !this.templateListEnd){
        this.templateListLoading = true
        this.getCollectTemplateDataFunc()
      } else if(val === 'recycleBin' && !this.recycleBinListEnd){
        this.recycleBinListLoading = true
        this.getRecycleBinDataFunc()
      }
    },
    // 跳转到 会员购买页面
    toBuyMemberFunc () {
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'upVip',
        displayContinueBtn: true,
      })
      // routerTo('/account/users/buy_member', '_blank')
    },
    // 跳转到简历模板页面
    toMoreTemplateFunc () {
      routerTo('/jianlimoban/', '_blank')
    },
    // 跳转到 导师辅导页面
    perfectUrlFunc() {
      let { count, first_order_token } = this.notSelectedMentorOrders;
      if(count > 1){
        routerTo('/account/users?index=3')
      }else{
        routerTo(`/service/pay_success/${ first_order_token }?source=cv`)
      }
    },
    changeConfirmState (val) {
      this.$emit('changeConfirmState', val)
    },
    // 获取 收藏的简历模板列表
    async getCollectTemplateDataFunc () {
      try {
        let res = await api.favorite.getFavorite()
        this.templateListLoading = false
        this.templateListEnd = true;
        if (res.code === 1000) {
          this.templateList = res.data.sample_cvs || []
        } else {
          console.log(res.message || res.msg)
        }
      } catch (error) {
        this.templateListLoading = false
        this.templateListEnd = true;
        console.log(error)
      }
    },
    // 获取 回收站简历列表
    async getRecycleBinDataFunc() {
      try {
        let res = await api.trash.getDeletedList()
        this.recycleBinListLoading = false;
        this.recycleBinListEnd = true;
        if (res.code === 1000) {
          this.$store.dispatch('app/hasCoverletter', res.data.has_coverletter)
          this.recycleBinList = res.data.cvs || []
        } else {
          console.log(res.message || res.msg)
        }
      } catch (error) {
        this.recycleBinListLoading = false;
        this.recycleBinListEnd = true;
        console.log(error)
      }
    },
    triggerCreateCvFunc (type) {
      this.$emit('triggerCreateCvFunc', type)
    },
    // 切换简历页
    changeResumePage(dataType, type){
      if(dataType === 'cvs'){
        if(type === 'prev'){
          this.myCvActiveIndex = this.myCvActiveIndex - 1 < 0 ? 0 : this.myCvActiveIndex - 1
        }else{
          this.myCvActiveIndex = this.myCvActiveIndex + 1 > this.cvsSwiper.list.length - 1 ? this.cvsSwiper.list.length - 1 : this.myCvActiveIndex + 1
        }
      }
      else if(dataType === 'deleteCvs'){
        if(type === 'prev'){
          this.delectCvActiveIndex = this.delectCvActiveIndex - 1 < 0 ? 0 : this.delectCvActiveIndex - 1
        }else{
          this.delectCvActiveIndex = this.delectCvActiveIndex + 1 > this.deleteCvsSwiper.list.length - 1 ? this.deleteCvsSwiper.list.length - 1 : this.delectCvActiveIndex + 1
        }
      }
    },
    // 修改简历名称
    editCvName(token, name) {
      this.renameModalData = {
        cvToken: token,
        cvName: name,
        show: !!token
      }
    },
    // 更新选择简历数据
    updateSelectCvData(data){
      this.selectCvData = {
        ...this.selectCvData,
        ...data
      }
    },
    /// 更新回收站弹窗数据
    updataTrashAlertBox(data){
      console.log(data)
      this.trashAlertBox = {
        ...this.trashAlertBox,
        ...data
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "./index.scss";
</style>
